type StringEntry = [string, string];
type StringProcessor = (str: string) => string;

export default function dump(entries: StringEntry[], dumpTarget: HTMLElement, keyProcessor: StringProcessor = str => str): void {
    for (const entry of entries) {
        dumpTarget.style.setProperty(keyProcessor(entry[0]), entry[1])
    }
}
